var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNeutral(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.009 512.009",
    style: {
      enableBackground: "new 0 0 512.009 512.009"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F7B239"
    },
    cx: 256.004,
    cy: 256.004,
    r: 256.004
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E09B2D"
    },
    d: "M121.499,390.501C29.407,298.407,22.15,153.608,99.723,53.204 c-8.593,6.638-16.861,13.895-24.743,21.777c-99.974,99.974-99.974,262.065,0,362.038s262.065,99.974,362.038,0 c7.881-7.881,15.138-16.15,21.777-24.743C358.392,489.85,213.593,482.593,121.499,390.501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D4D4D"
    },
    d: "M255.999,360.434c-73.191,0-142-28.501-193.754-80.255c-3.706-3.706-3.706-9.714,0-13.418 c3.706-3.706,9.714-3.706,13.418,0c99.438,99.438,261.235,99.438,360.671,0c3.707-3.706,9.714-3.706,13.42,0 c3.706,3.706,3.706,9.714,0,13.418C398.001,331.933,329.19,360.434,255.999,360.434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E09B2D"
    },
    d: "M255.999,399.146c-20.805,0-41.611-2.835-61.84-8.507c-5.045-1.414-7.989-6.652-6.575-11.699 c1.414-5.045,6.655-7.988,11.699-6.575c37.103,10.403,76.328,10.403,113.433,0c5.048-1.412,10.283,1.53,11.698,6.575 c1.414,5.047-1.53,10.283-6.575,11.699C297.61,396.309,276.806,399.146,255.999,399.146z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D4D4D"
    },
    d: "M110.285,239.432c-2.761,0-5.496-1.198-7.372-3.507c-3.303-4.067-2.683-10.044,1.385-13.347 c19.561-15.883,53.362-25.365,90.418-25.365c5.24,0,9.489,4.248,9.489,9.489s-4.248,9.489-9.489,9.489 c-32.84,0-62.17,7.896-78.456,21.121C114.503,238.736,112.386,239.432,110.285,239.432z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D4D4D"
    },
    d: "M401.715,239.432c-2.101,0-4.217-0.695-5.975-2.123c-16.288-13.225-45.616-21.121-78.456-21.121 c-5.242,0-9.489-4.248-9.489-9.489s4.247-9.489,9.489-9.489c37.056,0,70.858,9.482,90.418,25.365 c4.069,3.303,4.689,9.279,1.385,13.347C407.211,238.234,404.474,239.432,401.715,239.432z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutral);
export default __webpack_public_path__ + "static/media/neutral.e1e0a3a81efbb1f9bdca931d589f19b5.svg";
export { ForwardRef as ReactComponent };